import { render } from "./OrderManagement.vue?vue&type=template&id=77ff4322&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"

import "./OrderManagement.vue?vue&type=style&index=0&id=77ff4322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ff4322"]])

export default __exports__